/**
 * General popup
 * example use:
 * app.openPopup('general',{
 *  title:'Popup Title',
 *  content:'Text Content', // can also be JSX
 *  button:{
 *    title:'Button Title',
 *    action:( closePopup )=>{
 *      console.log(1);
 *      closePopup();
 *    }
 *  }
 * })
 */

import React from 'react';
import PropTypes from 'prop-types';
import { PopupButton, PopupContent, PopupTitle } from 'new-ui/Components/Popup';
import './General.css';

const GeneralPopup = (props) => {
  const {
    title, content, contents, rawContent = null, buttons, closePopup,
  } = props;
  return (
    <div className="general-popup">
      {
        rawContent
      }
      {
        title && <PopupTitle title={title} />
      }
      {
        content && <PopupContent>{content}</PopupContent>
      }
      {
        contents && contents.map((c) => (
          <PopupContent>{c}</PopupContent>
        ))
      }
      <div className="general-popup-actions">
        {
          buttons && buttons.map((action, idx) => (
            <PopupButton
              theme={action.theme}
              key={action.title ?? idx}
              title={action.title}
              action={async () => {
                if (action.action) await action.action(closePopup);
              }}
            />
          ))
        }
      </div>
    </div>
  );
};

GeneralPopup.propTypes = {
  title: PropTypes.node,
  content: PropTypes.any,
  rawContent: PropTypes.any,
  contents: PropTypes.array,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    theme: PropTypes.string,
    action: PropTypes.func,
  })),
  closePopup: PropTypes.func.isRequired,
};

export default GeneralPopup;
